module.exports = new __parcel__URL__("puzzle.e34e02fe.jpg").toString();